// extracted by mini-css-extract-plugin
module.exports = {"no-followers":"MyFollowersModal_no-followers__1e3u2","followers-container":"MyFollowersModal_followers-container__1lBIb"};